export default __webpack_public_path__ + "static/media/bag.673ce42e.svg";